import style from "./pageNotFound.module.css";

export function PageNotFound() {
  return (
    <div className={style.main}>
      <img
        src="https://res.cloudinary.com/therajatg/image/upload/v1657684630/social%20media/404_Error_jl0a9b.svg"
        alt="Page Not Found"
        className={style.main}
      />
    </div>
  );
}
